import React, { useEffect } from "react"

// import { ScrollTopButton } from "@components/scroll-top-button"

import { Footer } from "./footer"
import { FeefoWidget } from "./footer/feefo-widget"
import { MembershipsLogos } from "./footer/memberships-logos"
import { Header } from "./header"
import { GoogleShopping } from "./header/google-shopping"

const Layout = ({ location, children }) => {
  useEffect(() => {
    if (typeof window === "undefined") {
      return
    }

    const script = document.createElement("script")
    script.src = "https://api.feefo.com/api/javascript/first-fence"
    script.async = true

    script.setAttribute("type", "text/javascript")
    script.setAttribute("data-cookieyes", "cookieyes-functional")

    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])
  return (
    <div>
      <GoogleShopping location={location} />
      <Header location={location} />
      <div
        style={{
          minHeight: "100vh",
        }}
      >
        {children}
      </div>
      {/* <ScrollTopButton /> */}
      <FeefoWidget />
      <MembershipsLogos />
      <Footer location={location} />
    </div>
  )
}

export default Layout
